import produce from 'immer'
import moment from 'moment'
import React from 'react'

import { RequestedDepartmentFragment, UserInfoFragment } from '@/generated/graphql'

import { UserInfo } from '../onboarding.interface'
import {
  OnboardingPage0,
  OnboardingPage1,
  OnboardingPage2,
  OnboardingPage3,
  OnboardingPage4,
  OnboardingPage5,
  OnboardingPage6,
  OnboardingPage7,
} from './index'

interface OnboardingPagesProps {
  viewer: UserInfoFragment & { createdAt: Date; departments: RequestedDepartmentFragment[] }
  onModalClose: () => void
}

export const OnboardingPages: React.FC<OnboardingPagesProps> = ({ viewer, onModalClose }) => {
  const [pageIndex, setPageIndex] = React.useState<number>(0)
  const [userInfo, setUserInfo] = React.useState<UserInfo>({
    location: 'shanghai',
    seatNumber: '',
    school: '',
    schoolStartTime: moment(),
    schoolEndTime: moment(),
    company: '',
    aboutMe: '',
    skills: [],
    hobbies: [],
  })

  function onUserInfoChange(fn: (value: UserInfo) => void): void {
    const newState = produce(userInfo, fn)
    setUserInfo(newState)
  }

  const commonProps = {
    userInfo,
    onUserInfoChange,
    viewer,
  }

  const pages = [
    <OnboardingPage0 key={0} {...commonProps} onNext={() => setPageIndex(1)} />,
    <OnboardingPage1 key={1} {...commonProps} onPrevious={() => setPageIndex(0)} onNext={() => setPageIndex(2)} />,
    <OnboardingPage2 key={2} {...commonProps} onPrevious={() => setPageIndex(1)} onNext={() => setPageIndex(3)} />,
    <OnboardingPage3 key={3} {...commonProps} onPrevious={() => setPageIndex(2)} onNext={() => setPageIndex(4)} />,
    <OnboardingPage4 key={4} {...commonProps} onPrevious={() => setPageIndex(3)} onNext={() => setPageIndex(5)} />,
    <OnboardingPage5 key={5} {...commonProps} onPrevious={() => setPageIndex(4)} onNext={() => setPageIndex(6)} />,
    <OnboardingPage6 key={6} {...commonProps} onPrevious={() => setPageIndex(5)} onNext={() => setPageIndex(7)} />,
    <OnboardingPage7 key={7} {...commonProps} onNext={() => onModalClose()} />,
  ]

  return pages[pageIndex]
}
